<template>
  <v-container fluid pa-0>

    <v-row>
      <v-col cols="12" class="text-center">
        <h2 class="font-weight-thin">{{$t('components.profilepic.title')}}</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-row justify="center">
          <div class="web-cam-container"
               :class="{'container-default':hasWebcamAccess && pictureError == null && !pictureTaken || loading, 'container-success':pictureError == null && pictureTaken && !loading, 'container-error': !hasWebcamAccess || pictureError != null}">
            <v-row justify="center">
              <template v-show="hasWebcamAccess">
                <div v-if="showVideo" v-show="!pictureTaken && hasWebcamAccess" class="profilepic-absolute">
                  <Webcam webcam-id="profile-pic" @lostWebcamAccess="lostWebcamAccess()" @ready="webcamReady=true"
                          @gainedWebcamAccess="gainedWebcamAccess()" :handle-errors="false"
                          @videoRef="setVideoRef($event)"></Webcam>
                </div>
                <FaceScanner class="profilepic-absolute"
                             ref="faceScanner"
                             v-show="pictureTaken"
                             :final-url="finalUrl"
                ></FaceScanner>
<!--                <img :src="finalUrl" v-if="finalUrl" class="profilepic-absolute finalImage" key="img"/>-->

              </template>
              <div v-if="!hasWebcamAccess" class="text-center"
                   style="width: 300px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <v-icon size="50">mdi-close-circle-outline</v-icon>
                <h3 class="my-3">{{$t('components.profilepic.errors.problem')}}</h3>
                <p>{{$t('components.profilepic.errors.no_webcam_access')}}</p>
                <v-btn color="secondary" @click="openSettings()">{{$t('general.settings')}}</v-btn>
              </div>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-center">
        <template v-if="pictureError != null">
          {{$t('components.profilepic.'+pictureError)}}
        </template>
        <template v-else-if="canContinue">
          {{$t('components.profilepic.facedetection.continue')}}
        </template>
      </v-col>
      <v-col cols="12" class="text-center mt-5">
        <v-btn class="mx-3" color="secondary"
               @click="takePicture()"
               v-if="!pictureTaken"
               :disabled="!hasWebcamAccess || !webcamReady"
               :loading="loading"
        >
          {{$t('components.profilepic.takepicture')}}
        </v-btn>
        <v-btn class="mx-3" color="secondary" @click="tryAgain()" v-if="pictureTaken" :loading="loading" :disabled="finalUrl != null || parsingImage">
          {{$t('general.tryagain')}}
        </v-btn>
        <v-btn class="mx-3" color="primary" @click="next()"
               :disabled="!canContinue || !!finalUrl || pictureError!=null"
               :loading="parsingImage">
          {{$t('general.continue')}}
        </v-btn>
      </v-col>
      <v-col cols="12" class="text-center" v-if="canHidePicture">
        <v-btn text x-small @click="hidePicture()">{{$t('components.profilepic.facedetection.hide_picture.button')}}</v-btn>
      </v-col>
    </v-row>
    <v-dialog
        persistent
        v-model="showHidePictureDialog"
        width="500"
    >
      <v-card>
        <v-card-title
            class="headline white grey--text"
            primary-title
        >
          {{$t('components.profilepic.facedetection.hide_picture.areusure')}}
        </v-card-title>

        <v-card-text class="white grey--text">
          {{$t('components.profilepic.facedetection.hide_picture.warningmsg')}}
        </v-card-text>

        <v-divider class="grey lighten-4"></v-divider>

        <v-card-actions class="white grey--text">
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              text
              @click="showHidePictureDialog = false"
              :disabled="hiddenPictureAvatarLoading"
          >
            {{$t('general.back')}}
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="continueWithoutPicture()"
              :loading="hiddenPictureAvatarLoading"
          >
            {{$t('general.continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>
  import {cacheUrl} from "../../lib/cache";
  import {uploadBlob} from "../../lib/fileUploader";
  import {ASSESSMENT_STATE_JOURNEY} from '../../router/assessmentstate';
  // import PageHeading from "../../components/framework/PageHeading";
  import * as faceapi from 'face-api.js';
  import Webcam from "../../components/webcam/Webcam";
  import FaceScanner from "../../components/helpers/FaceScanner";
  import soundController from "../../lib/soundController";
  export default {
    name: "ProfilePic",
    components: {
      Webcam,
      FaceScanner
      // PageHeading
    },
    data: () => ({
      loading: false,
      pictureTaken: false,
      pictureError: null,
      canContinue: false,
      finalUrl: null,
      hasWebcamAccess: true,
      showVideo: true,
      parsingImage: false,
      webcamReady: false,
      uploaderTimeout: 90, //seconds
      showHidePictureDialog : false,
      hiddenPictureAvatarLoading:false
    }),
    computed: {
      canHidePicture(){
          return !this.$store.state.assessment.assessment.project.force_profile_pic;
      },
      shouldVerifyFace(){
          return this.$store.state.assessment.assessment.project.should_verify_face;
      },
    },
    methods: {
      hidePicture(){
         this.showHidePictureDialog=true;
      },
      continueWithoutPicture(){
        this.hiddenPictureAvatarLoading=true;
        this.uploadHiddenPicture().then(()=>{
          this.$store.dispatch('assessment/updateCurrentState', ASSESSMENT_STATE_JOURNEY);
          this.$router.replace({name: 'JourneyOrientation'});
          this.hiddenPictureAvatarLoading=false;
        }).catch((e)=>{
          this.hiddenPictureAvatarLoading=false;
          this.pictureError = 'errors.internetissue';
          this.showHidePictureDialog=false;
          throw e;
        });
      },
      uploadHiddenPicture(){
        return new Promise(((resolve, reject) => {
          const imgName=this.$store.state.assessment.assessment.person.gender==='female' ? 'female' : 'male';
          fetch('/img/avatars/'+imgName+'.png')
            .then((response)=>response.blob())
            .then((blob)=>{
              uploadBlob(blob, 'profilepic.png', () => {
                // console.log(e);//Progress
              }).then((result) => {
                const url = result.internal_url || result.url;
                this.$store.dispatch('assessment/saveProfilePicture', {key:url, hide_picture:1}).then((file) => {
                  resolve(file);
                }, (e) => {
                  reject(e);
                });
              }, (e)=>{
                reject(e);
              });
            });
        }));
      },
      setVideoRef(ref) {
        this.videoRef = ref;
      },
      next() {
        this.stopVideoStream();
        this.uploadPicture().then((file) => {

          clearTimeout(this._uploadTimeout);


          const fileUrl = file.internal_url || file.url;
          cacheUrl(fileUrl).then((url) => {
            this.$refs.faceScanner.stopScanningFace();
            this.finalUrl = url;
            this.parsingImage = false;
            this.canContinue = true;
            this.pictureError = null;
            soundController.success();

            setTimeout(() => {
              this.$router.replace({name: 'JourneyOrientation'});
            }, 4000);
          });
          this.$store.dispatch('assessment/updateCurrentState', ASSESSMENT_STATE_JOURNEY).then(
            ()=>{},
            (e)=>{
              this.parsingImage = false;
              this.pictureError = 'errors.internetissue';
              this.canContinue = false;
              this.$refs.faceScanner.stopScanningFace();
              throw e;
            },
          );
        }, (e)=>{
          clearTimeout(this._uploadTimeout);

          //could not upload
          this.parsingImage = false;
          this.pictureError = 'errors.internetissue';
          this.canContinue = false;
          this.$refs.faceScanner.stopScanningFace();
          throw e;
        });
      },
      lostWebcamAccess() {
        this.hasWebcamAccess = false;
      },
      gainedWebcamAccess() {
        this.hasWebcamAccess = true;
      },
      tryAgain() {
        this.pictureError = null;
        this.pictureTaken = false;
        this.canContinue = false;
        this.startVideoStream();
      },
      takePicture() {
        this.loading = true;
        soundController.picture();

        let imgCanvas = this.$refs.faceScanner.$refs.imgCanvas;
        const video = this.videoRef;
        imgCanvas.width = video.offsetWidth;
        imgCanvas.height = video.offsetHeight;
        let ctx = imgCanvas.getContext('2d');
        ctx.drawImage(
          video,
          0, 0,
          video.offsetWidth, video.offsetHeight
        );
        this.pictureTaken = true;
        setTimeout(() => {
          faceapi.detectAllFaces(imgCanvas, new faceapi.TinyFaceDetectorOptions()).then((detections) => {
            if (this.shouldVerifyFace && detections.length === 0) {
              soundController.beep();
              this.pictureError = 'facedetection.cannotsee';
              this.loading = false;
            } else if (this.shouldVerifyFace && detections.length > 1) {
              soundController.beep();
              this.pictureError = 'facedetection.morethanone';
              this.loading = false;
            } else {
              if(this.shouldVerifyFace){
                  this.canContinue = true;
                  this._detection = detections[0];
                  // this.$refs.faceScanner.startScanningFace(this._detection);
              }else{
                  this.canContinue = true;
              }
            }

            this.stopVideoStream();
            this.loading = false;
          });
        }, 50);
      },
      startVideoStream() {
        this.showVideo = true;
      },
      stopVideoStream() {
        this.showVideo = false;
      },
      uploadPicture() {
        //FAILSAFE: start the timeout function to see if an error has occured
        this._uploadTimeout = setTimeout(()=>{
          this.pictureError = 'errors.general';
          this.loading = false;
          this.parsingImage = false;
          this.$refs.faceScanner.stopScanningFace();
          // this.$refs.faceScanner.hideFaceScanner = true;
        },this.uploaderTimeout * 1000);

        this.parsingImage = true;

        if(this.shouldVerifyFace){
            this.$refs.faceScanner.startScanningFace(this._detection);
        }

        let imgCanvas = this.$refs.faceScanner.$refs.imgCanvas;

        return new Promise(((resolve, reject) => {

          imgCanvas.toBlob((blob) => {

            uploadBlob(blob, 'profilepic.png', () => {
              // console.log(e);//Progress
            }).then((result) => {

              this.$store.dispatch('assessment/saveProfilePicture', {key:result.url, hide_picture:0}).then((file) => {
                resolve(file);
              }, (e) => {
                reject(e);
              });
            }, (e)=>{
              reject(e);
            });
          });
        }));
      },
      openSettings() {
        this.$store.dispatch('settings/toggleSettingsDrawer', !this.$store.state.settings.isOpen);
      },
    },
    beforeDestroy() {
      // this.stopVideoStream();
    },
    mounted() {
      faceapi.nets.tinyFaceDetector.loadFromUri('/weights');
    },
  }
</script>

<style scoped>
  .web-cam-container {
    width: 350px;
    height: 350px;
    border-radius: 50%;

    overflow: hidden;
    position: relative;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;

    /*box-shadow: 0 0 8px #ea4c89, inset 0 0 8px #ea4c89;*/
    /*box-shadow: 0 0 8px #fff, inset 0 0 8px #fff;*/
    /*-webkit-animation: pulse 3s linear 1s infinite;*/
  }

  .web-cam-container.container-success {
    border: 2px solid forestgreen;
    box-shadow: 0 0 8px forestgreen, inset 0 0 8px forestgreen;
    -webkit-animation: pulsegreen 3s linear 1s infinite;
  }

  .web-cam-container.container-error {
    box-shadow: 0 0 8px darkred, inset 0 0 8px darkred;
    -webkit-animation: pulsered 3s linear 1s infinite;
    border: 2px solid darkred;
  }

  .web-cam-container.container-default {
    box-shadow: 0 0 8px #fff, inset 0 0 8px #fff;
    -webkit-animation: pulsewhite 3s linear 1s infinite;
    /*border: 10px solid rgba(255, 255, 255, 0.3);*/
  }

  .profilepic-absolute {
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*margin-left: -50%;*/
    width: 490px;
    max-height: 400px;
  }

  /*.inner {*/
  /*  background-color:transparent;*/
  /*  border-radius:50px;*/
  /*  box-shadow: 0 0 8px #ea4c89, inset 0 0 8px #ea4c89;*/
  /*  -webkit-animation: pulse 2s linear 1s infinite;*/
  /*  z-index: 5;*/
  /*}*/

  @-webkit-keyframes pulsewhite {
    0% { box-shadow:0 0 8px #fff, inset 0 0 8px #fff; }
    50% { box-shadow:0 0 18px #fff, inset 0 0 16px #fff; }
    100% { box-shadow:0 0 8px #fff, inset 0 0 8px #fff; }
  }

  @-webkit-keyframes pulsered {
    0% { box-shadow:0 0 8px darkred, inset 0 0 8px darkred }
    50% { box-shadow:0 0 18px darkred, inset 0 0 16px darkred; }
    100% { box-shadow:0 0 8px darkred, inset 0 0 8px darkred }
  }

  @-webkit-keyframes pulsegreen {
    0% { box-shadow:0 0 8px forestgreen, inset 0 0 8px forestgreen; }
    50% { box-shadow:0 0 18px forestgreen, inset 0 0 16px forestgreen; }
    100% { box-shadow:0 0 8px forestgreen, inset 0 0 8px forestgreen; }
  }

</style>
